module.exports = __webpack_public_path__ + "c2e2f13107aafd8845b785f77a73e986.svg";